"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M19.465 15.02l2.305 2.887H2.23l2.305-2.888V9.588c0-3.068 2.352-5.65 5.546-6.4v-.615c0-.939.86-1.702 1.919-1.702 1.059 0 1.918.763 1.918 1.702v.612c3.195.753 5.547 3.332 5.547 6.403v5.431zm-4.374 4.662c0 1.516-1.385 2.742-3.09 2.742-1.706 0-3.092-1.229-3.092-2.742h6.182z" }), "Notification");
//# sourceMappingURL=Notification.js.map